import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footerEkampus',
    templateUrl: './footerEkampus.component.html',
    styleUrls: ['./footerEkampus.component.css'],
    standalone: false
})
export class FooterEkampusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
